import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, featuredImage } from '../data/offer';
const highlights = ['Speed sessions, hills, tempo runs, long runs and recovery', 'Every workout written with reps, paces and progressions', 'For all levels — from first-timers to sub-3 marathoners', 'Print it or open it on your phone right at the track'];
export function FeaturedProduct() {
  return <section className="w-full bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="star-heading" data-id="element-80" data-mp="1czx6po2qlehn">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-81" data-mp="1hyqhv9ujwten">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-82" data-mp="1mze8vvis5a8v">
          <div className="order-2 lg:order-1" data-id="element-83" data-mp="1rrxvfhzg3fpt">
            <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-mint sm:text-xs" data-id="element-84" data-mp="1rspig4ez854h">
              <StarIcon className="h-4 w-4 fill-mint text-mint" aria-hidden="true" data-id="element-85" data-mp="zabpai4l57bq" />
              The star of the pack
            </p>
            <h2 id="star-heading" className="display-tight mt-5 font-display text-[32px] uppercase text-paper sm:text-[44px]" data-id="element-86" data-mp="17h5je3r0lzrg">
              +100 running workouts
              <span className="block text-mint" data-id="element-87" data-mp="xr45g4sdlxq9">ready to train</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-paper-dim sm:text-lg" data-id="element-88" data-mp="tq0sbq1pqfsq">
              The centerpiece of the pack: a full library of professional sessions you can run
              tomorrow. No planning, no guessing — pick the workout that fits the day and coach it.
            </p>

            <ul className="mt-7 space-y-3" data-id="element-89" data-mp="euuh8onrfqsj">
              {highlights.map(item => <li key={item} className="flex items-start gap-3" data-id="element-90" data-mp="aszklxgry1l3">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-deep" aria-hidden="true" data-id="element-91" data-mp="297u3h0mnbj8s" />
                  <span className="text-sm leading-relaxed text-paper sm:text-base" data-id="element-92" data-mp="2568v9sl23t4x">{item}</span>
                </li>)}
            </ul>

            <div className="mt-9 flex" data-id="element-93" data-mp="2is6mhizv1w5">
              <CtaButton size="lg" data-id="element-94" data-mp="2hqvkd1zafef">Get the pack — {PRICE}</CtaButton>
            </div>
          </div>

          <div className="order-1 overflow-hidden rounded-2xl border border-carbon-line bg-carbon-800 p-2 sm:p-3 lg:order-2" data-id="element-95" data-mp="3po9nnvdon7zv">
            <img src={featuredImage} alt="+100 Running Workouts — the featured bonus, shown with its workout sheets" className="w-full rounded-xl object-cover" loading="lazy" data-id="element-96" data-mp="3tpcz85op6hva" />
          </div>
        </div>
      </div>
    </section>;
}